export class SConstants {
  public static ITEMS_PER_PAGE = [10, 20, 50, 100, 500, 1000];

  public static APPS = [
  ]

  public static MOD_BASE = 'BASE'

  public static MODULES = [this.MOD_BASE, ...this.APPS.map(a => a.code)]

  public static QR_SCANNER_MAX_DIFF_MS = 500

  public static USERS_COLS = [
    { type: 'number', attr: 'id_user' },
    { type: 'text', attr: 'username' },
    { type: 'text', attr: 'fullname' },
    { type: 'text', attr: 'email' },
    { type: 'text', attr: 'group_name' },
    { type: 'bool', attr: 'active' },
    { type: 'date', attr: 'created_at' }
    //  { type: 'text', attr: 'template', noSearch: true }
  ]

  public static GROUPS_COLS = [
    {
      searchType: "select", type: 'text', attr: 'module', options: [
        {
          text: `modules.${this.MOD_BASE}`,
          value: this.MOD_BASE
        },
        ...this.APPS.map(a => {
          return {
            text: `modules.${a.code}`,
            value: a.code
          }
        })]
    },
    { type: 'text', attr: 'name' },]

  public static NEWS_COLS = [
    { type: 'text', attr: 'version', noSearch: true },
    { type: 'text', attr: 'module', noSearch: true },
    { type: 'text', attr: 'text', noSearch: true },
  ]

  public static LOG_COLS = [
    { type: 'translate', attr: 'action', tdStyle: "width:5%" },
    { type: 'text', attr: 'created_by_name', tdStyle: "width:5%" },
    { type: 'datetime', attr: 'created_at', tdStyle: "width:5%" },
    { type: 'json_viewer', attr: 'old_val', tdStyle: "width:40%", disabled: true, noSearch: true },
    { type: 'json_viewer', attr: 'new_val', tdStyle: "width:40%", disabled: true, noSearch: true }
  ]

  public static GROUPS_RIGHTS = ["r_create", "r_close", "r_edit", "r_extra_1", "r_extra_2", "r_extra_3", "r_extra_4", "r_extra_5", "r_extra_6"]

  public static STAMP_MAX_WIDTH = 512
  public static STAMP_MAX_HEIGHT = 512
  public static BROADCAST = "BROADCAST"

  public static DATE_TYPES = ['date', 'time', 'datetime', 'dh', 'hm', 'week', 'month']

  public static DB_EDITABLE_TABLES = ['constants', 'news']
  public static DB_DISABLED_ATTRS = ['db_comment', 'created_by', 'created_at', 'updated_by', 'updated_at']
  public static DB_CONCAT_FOREIGN = ["name", "code", "text", "attr", "type", "fullname", "email"];
  public static DB_ALLOW_ID_ATTRS = [];
  public static DB_TABLES_ONLY_NEW = []
  public static DB_SPECIAL_TYPES = {};
  public static DB_MULTI_SELECTS = {};

  public static IFTRAME_PADDING_PX = 8
  public static TABLE_FIXED_FROM_H = 400
  public static DEFAULT_REFRESH_TIME = 60
  public static REGEX_EMAIL = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/

  public static HOLIDAY_DAYS = ['*-01-01', '*-05-01', '*-05-08', '*-07-05', '*-07-06', '*-09-28', '*-10-28', '*-11-17', '*-12-24', '*-12-25', '*-12-26'];

  public static DATE_FILTER_BTNS = ["today", "yesterday", "this_week", "last_week", "this_month", "last_month", "this_year","last_year", "all"];

  public static MOBILE_FROM_W = 768;
  public static TABLET_FROM_W = 992;
}

